// extracted by mini-css-extract-plugin
export default {"accordionContainer":"Accordion_accordionContainer__g2F50","topName":"Accordion_topName__YKFC7","icon":"Accordion_icon__vbXox"};